import { render } from "./DashboardTable.vue?vue&type=template&id=5dab79c4&scoped=true&ts=true"
import script from "./DashboardTable.vue?vue&type=script&lang=ts"
export * from "./DashboardTable.vue?vue&type=script&lang=ts"

import "./DashboardTable.vue?vue&type=style&index=0&id=5dab79c4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dab79c4"]])

export default __exports__